import "vite/modulepreload-polyfill";
// Static files import
// { eager: true } is required to output the CSS to /dist/
import.meta.glob("../css/app.css", { eager: true });
import.meta.glob(["../../template-parts/blocks/**/*.css", "../../template-parts/blocks/**/*.js"], { eager: true });

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

import "./_animations";
import "./_fontawesome";
import "./_slider";

Alpine.plugin(collapse);

window.Alpine = Alpine;

Alpine.start();
